export default {
  methods: {
    fetchData: function(url, success, error, start = undefined, finished = undefined){
      const request = new XMLHttpRequest();
      request.onreadystatechange = function(){
        if(request.readyState == 1 && start != undefined){
          // start callback
          start();
        }
        if(request.readyState == 4){
          // finished callback
          if(finished != undefined){
            finished();
          }
          let response = JSON.parse(request.responseText);
          if(request.status == 200){
            // success callback
            success(response);
          } else {
            // error callback
            error(response);
          }
        }
      }

      request.open('GET', url);
      request.setRequestHeader('Content-Type', 'application/json');
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      request.send();



    }
  }
}
